module.exports = __webpack_public_path__ + "why5.png?15d71ed4e3679c88fafb7ab3f06be11e";